import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import CopyButton from "components/DesignComponents/CopyButton";
import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { usePermissions } from "shared/hooks/usePermissions";

import { EditSectionProps } from "./types";

const EditSection = ({
    children,
    isLoading,
    isEditable,
    sectionName,
    value,
    copiedValue,
    update,
    edit,
    cancel
}: EditSectionProps) => {
    const { t } = useTranslation();

    const {
        isUpdateDeviceNotAllowed,
        PERMISSIONS,
        getNoPermissionTooltipTitle
    } = usePermissions();

    return (
        <>
            <span>{sectionName}:</span>

            <span>
                <form onSubmit={update}>
                    <div>{children}</div>

                    <div
                        css={css({
                            display: "flex",
                            alignItems: "center",
                            columnGap: "8px"
                        })}
                    >
                        <TooltipGeneral
                            title={getNoPermissionTooltipTitle(
                                PERMISSIONS.DeviceUpdate
                            )}
                            placement={TOOLTIP_PLACEMENT.Top}
                        >
                            <span>
                                <Button
                                    disableRipple
                                    color={BUTTON_COLORS.Secondary}
                                    size={BUTTON_SIZES.Tiny}
                                    variant={BUTTON_VARIANTS.TextOnly}
                                    isLoading={isLoading}
                                    disabled={isUpdateDeviceNotAllowed}
                                    onClick={isEditable ? update : edit}
                                >
                                    {isEditable
                                        ? t("Button##save")
                                        : t("Button##edit")}
                                </Button>
                            </span>
                        </TooltipGeneral>

                        {isEditable && (
                            <Button
                                disableRipple
                                color={BUTTON_COLORS.Secondary}
                                size={BUTTON_SIZES.Tiny}
                                variant={BUTTON_VARIANTS.TextOnly}
                                disabled={isLoading}
                                onClick={cancel}
                            >
                                {t("Button##cancel")}
                            </Button>
                        )}

                        {value && !isEditable && copiedValue && (
                            <CopyButton
                                size={BUTTON_SIZES.Tiny}
                                copiedValue={copiedValue}
                            />
                        )}
                    </div>
                </form>
            </span>
        </>
    );
};

export default EditSection;
